export default function (value: string) {
  const input = document.createElement('input');
  input.value = value;
  document.body.insertBefore(input, document.body.firstChild);
  input.focus();
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
}
